// page.tsx
"use client";

import { useState, Suspense, lazy } from "react";
import LockScreen from "../../Components/Lockscreen";
import "./Dublin.css";

import { DublinMail } from "./DublinAssets/DublinMailContent";
import { DublinNoteContent } from "./DublinAssets/DublinNoteContent";
import { DublinMessageContent } from "./DublinAssets/DublinMessagesContent";
import { DublinCallContent } from "./DublinAssets/DublinCallContent";
import { Chat_content } from "../../Components/MessageApp/MessagesInterfaces";
import { DublinTweetContent } from "./DublinAssets/DublinTweeterContent";
import CallApp from "../../Components/CallApp/CallApp";
import { DublinPhotoContent } from "./DublinAssets/DublinPhotoContent";
import HomeIcon from "../../Components/Icons/HomeIcon";
import TheGramStoriesApp from "../../Components/TheGramStoriesApp/TheGramStoriesApp";
import { DublinTheGramStoriesContent } from "./DublinAssets/DublinTheGramStoriesContent";

const Messages = lazy(() => import("../../Components/MessageApp/Messages"));
const Photos = lazy(() => import("../../Components/PhotosApp/Photos"));
const AppsMenu = lazy(() => import("../../Components/AppsMenu/AppsMenuDublin"));
const NotesApp = lazy(() => import("../../Components/NotesApp/NotesApp"));
const TweeterApp = lazy(() => import("../../Components/TweeterApp/TweeterApp"));

const MailApp = lazy(() => import("../../Components/MailApp/MailApp"));

function Dublin() {
  const [isLocked, setIsLocked] = useState(true);
  const [activeApp, setActiveApp] = useState("appsmenu");
  const [messages, setMessages] = useState(DublinMessageContent);
  const [messageNotifications, setMessageNotifications] = useState(0);

  const unlock = () => {
    setIsLocked(false);
  };

  const handleStateChange = (chat: Chat_content) => {
    const chatIndex = messages.findIndex(
      (message) => message.name === chat.name
    );
    const previousMessage = messages[chatIndex];
    if (previousMessage && !previousMessage.read) {
      const newMessages = [...messages];
      newMessages[chatIndex] = {
        ...newMessages[chatIndex],
        read: true,
      };
      setMessages(newMessages);
      setMessageNotifications(messageNotifications - 1);
    }
  };

  const renderApp = () => {
    switch (activeApp) {
      case "messages":
        return (
          <Messages
            influencerMessageContent={messages}
            theGram={false}
            handleStateChange={handleStateChange}
          />
        );
      case "phone":
        return <CallApp callContent={DublinCallContent} />;
      case "photos":
        return <Photos albums={DublinPhotoContent} />;
      case "notes":
        return <NotesApp noteContent={DublinNoteContent} />;
      case "appsmenu":
        return (
          <AppsMenu
            isLocked={isLocked}
            setActiveApp={setActiveApp}
            messageNotifications={messageNotifications}
          />
        );
      case "tweeter":
        return <TweeterApp tweeterContent={DublinTweetContent} />;
      case "mail":
        return <MailApp emails={DublinMail} />;
      case "thegram":
        return (
          <TheGramStoriesApp
            content={DublinTheGramStoriesContent}
            notifications={0}
            onReturnHome={() => setActiveApp("appsmenu")}
          />
        );

      // case "internet":
      //   return (
      //     <InternetApp
      //       headerImage={InternetBanner}
      //       bodyImage={InternetArtical}
      //       logoIcon={InternetLogo}
      //       searchBarText="Hasina Jafari Mwanga"
      //       articleTitle="Hasina Jafari Mwanga"
      //       articleDate=""
      //       author="President of Tanzania"
      //       photoCaption="via Betty images"
      //       bodyText="President of Tanzania"
      //       website=""
      //     />
      //   );
      default:
        return null;
    }
  };

  return (
    <div className="Mystery">
      <div className="phone-wrapper">
        <div className={`Dublinscreen ${activeApp}`}>
          {isLocked ? (
            <div
              className={`lockscreen-container ${
                isLocked ? "visible" : "hidden"
              }`}
            >
              <LockScreen unlock={unlock} password="252210" />
            </div>
          ) : null}

          <Suspense
            fallback={
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                Loading...
              </div>
            }
          >
            {renderApp()}
          </Suspense>
          <div className="home-button-container">
            <HomeIcon onClick={() => setActiveApp("appsmenu")} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dublin;
